import { render, staticRenderFns } from "./wxNotification.vue?vue&type=template&id=79d18daa&"
import script from "./wxNotification.vue?vue&type=script&lang=js&"
export * from "./wxNotification.vue?vue&type=script&lang=js&"
import style0 from "./wxNotification.vue?vue&type=style&index=0&id=79d18daa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports